export default __webpack_public_path__ + "static/media/carpenter-1.c5e41deb.jpg";